import { render, staticRenderFns } from "./ForeignNews.vue?vue&type=template&id=6385527b&scoped=true"
import script from "./ForeignNews.vue?vue&type=script&lang=js"
export * from "./ForeignNews.vue?vue&type=script&lang=js"
import style0 from "./ForeignNews.vue?vue&type=style&index=0&id=6385527b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385527b",
  null
  
)

export default component.exports